import React from 'react';
import {connect} from "react-redux";
import Popup from "../../../parts/Popup";
import CommonTab from "../../../parts/CommonTabClass";

class InitiatorPopupComponent extends CommonTab {
    state = {
        contactorPopup: this.props.contactorPopup,
        errors: [],
        validateFields: [
            'initiatortypename',
            'initiatortypenameeng'
        ]
    };

    changeState(name, e) {
        let temp = this.state.contactorPopup;
        temp[name] = e.value;
        this.setState({contactorPopup: temp});
    }

    render() {
        let {contactorPopup, errors, validateFields} = this.state;
        let {close} = this.props;
        return (
            <Popup openClose={close}>
                <div className={'popup-content-types'}>
                    <form onSubmit={event => {
                        event.preventDefault();
                        this.formValidation(contactorPopup, validateFields);
                    }}>
                        <h2>{this.props.button} Initiator Type</h2>
                        <table className={'table table-striped'} align={'right'}>
                            <tbody>
                            <tr>
                                <td>Initiator Type Name:</td>
                                <td className={errors.indexOf('initiatortypename') !== -1 ? 'error' : ''}>
                                    <input
                                        type={'text'}
                                        value={contactorPopup.initiatortypename}
                                        onChange={(e) => {
                                            this.changeState('initiatortypename', e.target);
                                        }}
                                    />
                                    {errors.indexOf('initiatortypename') !== -1 ? <span className="errorText">Initiator Type Name</span> : '' }
                                </td>
                            </tr>
                            <tr>
                                <td>Initiator Type Name Eng:</td>
                                <td className={errors.indexOf('initiatortypenameeng') !== -1 ? 'error' : ''}>
                                    <input
                                        type={'text'}
                                        value={contactorPopup.initiatortypenameeng}
                                        onChange={(e) => {
                                            this.changeState('initiatortypenameeng', e.target);
                                        }}
                                    />
                                    {errors.indexOf('initiatortypenameeng') !== -1 ? <span className="errorText">Initiator Type Name Eng</span> : '' }
                                </td>
                            </tr>

                            </tbody>
                        </table>
                        <input type={"submit"} className={"btn btn-primary"} value={this.props.button}/>
                    </form>
                </div>
            </Popup>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    let content = {};
    state.initiatorData.initiatorTypes.map((item) => {
        if (item.initiatortypeid == ownProps.id) {
            content = item;
        }
    });
    return {
        contactorPopup: Object.assign({}, content)
    }
};

const InitiatorPopup = connect(mapStateToProps)(InitiatorPopupComponent);

export default InitiatorPopup;